import { Deserializer } from 'jsonapi-serializer';

export const deserializer = new Deserializer({
  includeId: true,
  keyForAttribute: 'camelCase',
});
